<template>
  <AppRadioGroup
    v-model="crossing.type"
    :label="$tt('crossing.radio_label')"
    :rules="[required]"
    class="mb-5"
    inline
  >
    <AppRadio v-for="(label, value) in borderTypes" :value :label />
  </AppRadioGroup>
  <TextField
    v-if="crossing.type == 'land'"
    v-model="crossing.border"
    :label="$tt('crossing.border')"
    :rules="[required]"
  />
  <TextField
    v-else-if="crossing.type == 'sea'"
    v-model="crossing.ship"
    :label="$tt('crossing.ship')"
    :rules="[required]"
  />
  <TextField
    v-else-if="crossing.type == 'air'"
    v-model="crossing.flight"
    :label="$tt('crossing.flight')"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
import type { Crossing } from '~/types';

const crossing = defineModel<Crossing>({ required: true });

const { required } = useValidation();
const { tt } = useLocalization();

const borderTypes: Record<Crossing['type'], string> = {
  land: tt('crossing.land'),
  sea: tt('crossing.sea'),
  air: tt('crossing.air'),
};
</script>